import Axios from "../redux/setupAxios";
import { Urls } from "../app/utils/constants";
import { microserviceNames } from "../app/utils/constants";

const proxyName = microserviceNames.stakeholderMicroserviceWithoutToken;

export async function getIndustryCategoriesByVoen(voenIsRequired) {
    return (await Axios.get(`${proxyName}/${Urls.IndustryCategory}?voen=${voenIsRequired}`)).data;
}